import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Item from "./Item";
import LoadMore from "core/components/LoadMore";

export default function PostsGrid({
  xs,
  sm,
  md,
  lg,
  xl,
  items,
  hasMore,
  onLoadMore,
  loading,
  nextPage,
}) {
  return (
    <Box
      sx={{ pl: { xs: 2, sm: 0 }, pr: { xs: 2, sm: 0 } }}
      test-id="ArenaPostsGrid"
    >
      <Grid container spacing={3}>
        {items.map((item, index) => (
          <Grid
            item
            container
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            key={index}
          >
            <Item
              variant="TITLE_OUTSIDE"
              showDescription
              post={item}
              smallTitle={12 / md > 3}
            />
          </Grid>
        ))}
      </Grid>

      {/* Показываем LoadMore компонент внизу грида */}
      {hasMore && !loading && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <LoadMore key={nextPage} onLoadMore={onLoadMore} />
        </Box>
      )}
    </Box>
  );
}

PostsGrid.propTypes = {
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      thumbnails: PropTypes.array,
      openInNewWindow: PropTypes.bool,
    })
  ),
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
  loading: PropTypes.bool,
  nextPage: PropTypes.number,
};
